/*
  PDP Pack/Color section behavior:
  - swaps the main gallery image when a thumbnail is clicked
  - tracks the selected value for every product option (Pack, Color, ...)
  - matches the combination against the real Shopify variants (price,
    compare_at_price, id, availability) and updates the page live
  - optional badges (e.g. "MOST POPULAR" / "BEST VALUE") per pack value —
    edit PACK_BADGES below to match your own variant option values
  - runs a countdown-timer urgency bar if the section setting is enabled
*/
(function () {
  var PACK_BADGES = {
    '2-pack': 'MOST POPULAR',
    '3-pack': 'BEST VALUE'
  };

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (window.Shopify && window.Shopify.formatMoney && format) {
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + value;
  }

  document.querySelectorAll('.pdp-wrap').forEach(function (root) {
    var variantsScript = root.querySelector('[data-variants-json]');
    if (!variantsScript) return;
    var variants = JSON.parse(variantsScript.textContent);

    var optionCount = variants[0] ? variants[0].options.length : 1;
    var selected = [];
    for (var i = 0; i < optionCount; i++) {
      var checked = root.querySelector('[data-option-position="' + (i + 1) + '"]:checked');
      selected[i] = checked ? checked.value : (variants[0] ? variants[0].options[i] : null);
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (val, idx) { return val === selected[idx]; });
      });
    }

    function render() {
      var variant = findVariant();
      if (!variant) return;

      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare-price]');
      var offEl = root.querySelector('[data-percent-off]');
      var addBtn = root.querySelector('[data-addcart-button]');
      var addPrice = root.querySelector('[data-addcart-price]');
      var addLabel = root.querySelector('[data-addcart-label]');
      var variantInput = root.querySelector('[data-variant-id]');

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.hidden = false; }
        var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        if (offEl) { offEl.textContent = pct + '% OFF'; offEl.hidden = false; }
      } else {
        if (compareEl) compareEl.hidden = true;
        if (offEl) offEl.hidden = true;
      }

      if (variantInput) variantInput.value = variant.id;
      if (addPrice) addPrice.textContent = formatMoney(variant.price);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available
          ? ('Add to Cart — ' + formatMoney(variant.price))
          : 'Sold Out';
      }

      root.querySelectorAll('[data-pack-price]').forEach(function (el) {
        var handle = el.getAttribute('data-pack-price');
        var match = variants.find(function (v) {
          return v.options.some(function (val) {
            return val && val.toLowerCase().replace(/\s+/g, '-') === handle;
          });
        });
        if (!match) return;

        var nowEl = el.querySelector('[data-pack-now]');
        var compareWrapEl = el.querySelector('[data-pack-compare-wrap]');
        var compareValEl = el.querySelector('[data-pack-compare-val]');
        var saveEl = el.querySelector('[data-pack-save]');

        if (nowEl) nowEl.textContent = formatMoney(match.price);

        if (match.compare_at_price && match.compare_at_price > match.price) {
          if (compareWrapEl) compareWrapEl.hidden = false;
          if (compareValEl) compareValEl.textContent = formatMoney(match.compare_at_price);
          if (saveEl) saveEl.textContent = 'Save ' + formatMoney(match.compare_at_price - match.price);
        } else {
          if (compareWrapEl) compareWrapEl.hidden = true;
          if (saveEl) saveEl.textContent = '';
        }
      });
      root.querySelectorAll('[data-pack-badge]').forEach(function (el) {
        var handle = el.getAttribute('data-pack-badge');
        el.textContent = PACK_BADGES[handle] || '';
      });

      root.querySelectorAll('[data-selected-value]').forEach(function (el) {
        var block = el.closest('[data-option-index]');
        if (!block) return;
        var idx = parseInt(block.getAttribute('data-option-index'), 10);
        el.textContent = selected[idx] || '';
      });
    }

    root.querySelectorAll('input[data-option-position]').forEach(function (input) {
      input.addEventListener('change', function () {
        var pos = parseInt(input.getAttribute('data-option-position'), 10) - 1;
        selected[pos] = input.value;

        input.closest('.pdp-packs,.pdp-colors').querySelectorAll('label').forEach(function (label) {
          label.classList.remove('is-selected');
        });
        input.closest('label').classList.add('is-selected');

        render();
      });
    });

    root.querySelectorAll('[data-thumb-index]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-thumb-index');
        root.querySelectorAll('[data-thumb-index]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        root.querySelectorAll('[data-gallery-image]').forEach(function (img) {
          var match = img.getAttribute('data-gallery-image') === index;
          img.hidden = !match;
          img.classList.toggle('is-active', match);
        });
      });
    });

    render();

    var form = root.querySelector('.pdp-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-addcart-button]');
        if (btn) btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: form.querySelector('[data-variant-id]').value, quantity: 1 })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            if (btn) btn.disabled = false;
          });
      });
    }

    var countdown = root.querySelector('[data-countdown]');
    if (countdown) {
      var minutes = parseInt(countdown.getAttribute('data-minutes'), 10) || 30;
      var storageKey = 'pdp-countdown-end';
      var end = parseInt(sessionStorage.getItem(storageKey), 10);
      if (!end || end < Date.now()) {
        end = Date.now() + minutes * 60 * 1000;
        sessionStorage.setItem(storageKey, String(end));
      }
      var display = countdown.querySelector('[data-countdown-display]');
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (display) display.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      setInterval(tick, 1000);
    }
  });
})();
